<template>
  <div class="bg-video-wrap">
    <video
      ref="video"
      class="bg-video"
      v-bind="$attrs"
      preload="auto"
      webkit-playsinline="true"
      playsinline="true"
      x5-video-player-type="h5"
      x5-video-orientation="portraint"
      x5-video-player-fullscreen="true"
      :src="src"
      v-on="$listeners"
      @canplay="handleCanplay"
      @playing="handlePlaying"
      @click="firstPlay"
    />
    <span v-show="canskip" class="btn-rb skip-btn" @click="skip">跳过</span>
  </div>
</template>

<script>
export default {
  name: 'BgVideo',
  props: {
    filename: {
      type: String,
      required: true,
    },
    canskip: {
      type: Boolean,
    },
  },
  data () {
    return {
      played: false,
    }
  },
  computed: {
    src () {
      return require(`../assets/video/bg/${this.filename}.mp4`)
    },
  },
  methods: {
    handleCanplay () {
      if (!this.$attrs.autoplay) {
        return
      }
      this.firstPlay()
    },
    firstPlay () {
      if (!this.played) {
        this.play()
      }
    },
    play () {
      if (this.$refs.video) {
        this.$refs.video.play()
      }
    },
    handlePlaying () {
      this.$emit('playing')
      this.played = true
    },
    pause () {
      this.$refs.video.pause()
    },
    skip () {
      this.pause()
      this.$emit('ended')
    },
  },
}
</script>

<style lang="scss" scoped>
.bg-video-wrap,
.bg-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.skip-btn {
  z-index: 101;
  font-size: 0.24rem;
  color: #fff;
  cursor: pointer;
}
</style>
